<template>
  <div class="bg-white mx-3 rounded-xl">
    <div class="flex justify-between">
      <div class="m-3 flex justify-between flex-col md:flex-row gap-3" style="width: 100%">
        <div class="flex gap-5 justify-between flex-col md:flex-row">
          <input v-model="Fullname" type="text" class="bg-gray-300 rounded-full p-1 px-3" placeholder="Search Task"
            @change="filterByEmployee" />
          <input v-model="taskName" type="text" class="bg-gray-300 rounded-full p-1 px-3" placeholder="Search Task"
            @change="filterByTaskName" />
          <select class="bg-gray-300 rounded-full p-1.5 w-auto px-3" v-model="searchQuery">
            <option selected disabled value="">
              Filter by Urgency
            </option>
            <option v-for="urgency of urgencies" :key="urgency.id" class="cursor-pointer">
              {{ urgency }}
            </option>
          </select>
        </div>
        <TaskModal />
      </div>
    </div>
    <div class="overflow-x-auto md:overflow-x-hidden">
      <table class="table-auto text-xs sm:text-sm border-spacing-3" style="width: 100%">
        <thead class="text-left bg-gray-300 text-black">
          <tr>
            <th class="p-2">Employee Name</th>
            <th class="p-2">Task Name</th>
            <th class="p-2">Issued By</th>
            <th class="p-2">Start Date</th>
            <th class="p-2">End Date</th>
            <th class="p-2">Status</th>
            <th class="p-2">Urgency</th>
            <th class="p-2">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="employee of employees" :key="employee.id" class="border-b-1.5">
            <td class="p-2 flex gap-1" style="align-items: center">
              <div class="w-7 h-7 rounded-full bg-gray-500 hidden md:block">
                <img class="w-7 h-7 rounded-full" :src="employee.avatar" />
              </div>

              <span class="text-sm">{{ employee.name }}</span>
            </td>
            <td class="p-2">
              {{ employee.tasks[0].taskName }}
            </td>
            <td class="p-2">
              {{ employee.tasks[0].issuedBy }}
            </td>
            <td class="p-2">{{ employee.tasks[0].startDate }}</td>
            <td class="p-2">{{ employee.tasks[0].endDate }}</td>
            <td class="p-2" :class="{
              'text-green-600': formatStatus(employee.tasks[0].status),
              'text-yellow-600': formatStatus(employee.tasks[0].status),
              'text-red-600': formatStatus(employee.tasks[0].status),
            }">
              {{ employee.tasks[0].status }}
            </td>
            <td class="p-2">
              {{ employee.tasks[0].urgency }}
            </td>
            <td class="p-2">
              <button class="h-3 p-2 rounded-full m-auto">
                <img class="h-3" src="@/assets/icons/vertical-dots.png" />
              </button>
            </td>

            <div class="overflow-x-auto md:overflow-x-hidden hidden">
              <table class="table-auto text-xs sm:text-sm border-spacing-3" style="width: 100%">
                <thead class="text-left bg-gray-300 text-black">
                  <tr>
                    <th class="p-2">Task Name</th>
                    <th class="p-2">Issued By</th>
                    <th class="p-2">Start Date</th>
                    <th class="p-2">End Da]te</th>
                    <th class="p-2">Status</th>
                    <th class="p-2">Urgency</th>
                    <th class="p-2">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="task of employee.tasks" :key="task.id" class="border-b-1.5">
                    <td class="p-2">{{ task.taskName }}</td>
                    <td class="p-2">{{ task.issuedBy }}</td>
                    <td class="p-2">{{ task.startDate }}</td>
                    <td class="p-2">{{ task.endDate }}</td>
                    <td class="p-2" :class="{
                      'text-green-600': formatStatus(task.status),
                      'text-yellow-600': formatStatus(task.status),
                      'text-red-600': formatStatus(task.status),
                    }">
                      {{ task.status }}
                    </td>
                    <td class="p-2">
                      {{ task.urgency }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TaskModal from "@/components/tasks/Modal.vue";
export default {
  data() {
    return {
      components: {
        TaskModal,
      },
      searchQuery: "",
      taskName: null,
      Fullname: null,
      tasks: [
        {
          id: 1,
          taskName: "System X Maintainance",
          issuedBy: "Erickson Maxwell",
          startDate: "01/08/2022",
          endDate: "01/08/2022",
          status: "Ongoing",
          urgency: "Mild",
          action: ["edit", "delete"],
          actionIcon: "@/assets/icons/vertical-dots.png",
        },
        {
          id: 2,
          taskName: "System Y Design",
          issuedBy: "Erickson Maxwell",
          startDate: "01/08/2022",
          endDate: "01/08/2022",
          status: "Late",
          urgency: "Urgent",
          action: ["edit", "delete"],
          actionIcon: "@/assets/icons/vertical-dots.png",
        },
        {
          id: 3,
          taskName: "System K Design",
          issuedBy: "Erickson Maxwell",
          startDate: "01/08/2022",
          endDate: "01/08/2022",
          status: "Completed",
          urgency: "Trivial",
          action: ["edit", "delete"],
          actionIcon: "@/assets/icons/vertical-dots.png",
        },
        {
          id: 4,
          taskName: "System Y Design",
          issuedBy: "Erickson Maxwell",
          startDate: "01/08/2022",
          endDate: "01/08/2022",
          status: "Completed",
          urgency: "Mild",
          action: ["edit", "delete"],
          actionIcon: "@/assets/icons/vertical-dots.png",
        },
      ],
      urgencies: ["All", "Mild", "Urgent", "Trivial"],
      employees: [
        {
          id: 1,
          name: "Erickson Maxwell",
          avatar:
            "https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png",
          tasks: [
            {
              id: 1,
              taskName: "System X Maintainance",
              issuedBy: "Erickson Maxwell",
              startDate: "01/08/2022",
              endDate: "01/08/2022",
              status: "Ongoing",
              urgency: "Mild",
              action: ["edit", "delete"],
              actionIcon: "@/assets/icons/vertical-dots.png",
            },
            {
              id: 2,
              taskName: "System Y Design",
              issuedBy: "Erickson Maxwell",
              startDate: "01/08/2022",
              endDate: "01/08/2022",
              status: "Late",
              urgency: "Urgent",
              action: ["edit", "delete"],
              actionIcon: "@/assets/icons/vertical-dots.png",
            },
          ],
        },
        {
          id: 2,
          name: "John Maxwell",
          avatar:
            "https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png",
          tasks: [
            {
              id: 2,
              taskName: "System Y Design",
              issuedBy: "Erickson Maxwell",
              startDate: "01/08/2022",
              endDate: "01/08/2022",
              status: "Late",
              urgency: "Urgent",
              action: ["edit", "delete"],
              actionIcon: "@/assets/icons/vertical-dots.png",
            },
            {
              id: 3,
              taskName: "System K Design",
              issuedBy: "Erickson Maxwell",
              startDate: "01/08/2022",
              endDate: "01/08/2022",
              status: "Completed",
              urgency: "Trivial",
              action: ["edit", "delete"],
              actionIcon: "@/assets/icons/vertical-dots.png",
            },
            {
              id: 4,
              taskName: "System Y Design",
              issuedBy: "Erickson Maxwell",
              startDate: "01/08/2022",
              endDate: "01/08/2022",
              status: "Completed",
              urgency: "Mild",
              action: ["edit", "delete"],
              actionIcon: "@/assets/icons/vertical-dots.png",
            },
          ],
        },
        {
          id: 3,
          name: "Tom Maxwell",
          avatar:
            "https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png",
          tasks: [
            {
              id: 2,
              taskName: "System Y Design",
              issuedBy: "Erickson Maxwell",
              startDate: "01/08/2022",
              endDate: "01/08/2022",
              status: "Late",
              urgency: "Urgent",
              action: ["edit", "delete"],
              actionIcon: "@/assets/icons/vertical-dots.png",
            },
            {
              id: 3,
              taskName: "System K Design",
              issuedBy: "Erickson Maxwell",
              startDate: "01/08/2022",
              endDate: "01/08/2022",
              status: "Completed",
              urgency: "Trivial",
              action: ["edit", "delete"],
              actionIcon: "@/assets/icons/vertical-dots.png",
            },
          ],
        },
        {
          id: 4,
          name: "Jackson Maxwell",
          avatar:
            "https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png",
          tasks: [
            {
              id: 2,
              taskName: "System Y Design",
              issuedBy: "Erickson Maxwell",
              startDate: "01/08/2022",
              endDate: "01/08/2022",
              status: "Late",
              urgency: "Urgent",
              action: ["edit", "delete"],
              actionIcon: "@/assets/icons/vertical-dots.png",
            },
            {
              id: 4,
              taskName: "System Y Design",
              issuedBy: "Erickson Maxwell",
              startDate: "01/08/2022",
              endDate: "01/08/2022",
              status: "Completed",
              urgency: "Mild",
              action: ["edit", "delete"],
              actionIcon: "@/assets/icons/vertical-dots.png",
            },
          ],
        },
        {
          id: 5,
          name: "Jane Maxwell",
          avatar:
            "https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png",
          tasks: [
            {
              id: 3,
              taskName: "System K Design",
              issuedBy: "Erickson Maxwell",
              startDate: "01/08/2022",
              endDate: "01/08/2022",
              status: "Completed",
              urgency: "Trivial",
              action: ["edit", "delete"],
              actionIcon: "@/assets/icons/vertical-dots.png",
            },
            {
              id: 4,
              taskName: "System Y Design",
              issuedBy: "Erickson Maxwell",
              startDate: "01/08/2022",
              endDate: "01/08/2022",
              status: "Completed",
              urgency: "Mild",
              action: ["edit", "delete"],
              actionIcon: "@/assets/icons/vertical-dots.png",
            },
          ],
        },
      ],
    };
  },
  methods: {
    formatStatus(text) {
      text = text.toLowerCase();
      if (text === "completed") {
        return true;
      } else if (text === "late") {
        return true;
      } else if (text === "ongoing") {
        return true;
      }
    },
  },
  computed: {
    filterTasks() {
      if (
        this.searchQuery.toLowerCase() === "all" ||
        this.searchQuery.toLowerCase() === ""
      ) {
        return this.tasks;
      } else {
        return this.tasks.filter(
          (task) =>
            task.urgency.toLowerCase() === this.searchQuery.toLowerCase()
        );
      }
    },
    filterByTaskName() {
      if (this.taskName) {
        return this.tasks.filter((task) =>
          this.taskName
            .toLowerCase()
            .split(" ")
            .every((letter) => task.taskName.toLowerCase().includes(letter))
        );
      } else {
        return this.tasks;
      }
    },
  },
  components: { TaskModal },
};
</script>
